export type AcceptedAudioFormat = {
	readonly mimeType: string;
	readonly extension: string;
	readonly label: string;
};

export type RecordingPolicyPayload = {
	readonly segmentMaxBytes: number;
	readonly maxSegments: number;
	readonly maxDurationMs: number;
	readonly deviceRetentionMs: number;
	readonly acceptedAudioFormats: readonly AcceptedAudioFormat[];
};

export type RecordingPolicyFetchedAction = {
	type: 'RECORDING_POLICY_FETCHED';
	payload: RecordingPolicyPayload;
};

export default (payload: RecordingPolicyPayload): RecordingPolicyFetchedAction => ({
	type: 'RECORDING_POLICY_FETCHED',
	payload,
});
